import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class UploadIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="36" height="25.954" viewBox="0 0 36 25.954"><path d="M18 0a10.46 10.46 0 0 1 10.4 9.249 8.37 8.37 0 0 1-.772 16.705H7.116a7.116 7.116 0 0 1 0-14.233h.497A10.468 10.468 0 0 1 18 0zm-.496 21.428h1.853v-9.395l3.478 3.735L24 14.524 18.429 8.57l-5.572 5.953 1.165 1.244 3.478-3.735z"/></svg>
        )
    }
}

export default withCssClassName(UploadIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/upload-icon.js